module.exports = __webpack_public_path__ + "static/hero-51910fce766bd6048afbea947d1516e3.jpg";